import Icon from '../../../components/AppIcon';
import { formatNumber } from '../../../utils/formatNumber';

const PortfolioStats = ({ stats }) => {
  const statCards = [
    {
      label: 'إجمالي الصور',
      value: formatNumber(stats?.totalImages),
      icon: 'Image',
      color: 'text-blue-600 dark:text-blue-400',
      bgColor: 'bg-blue-500/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 gap-3 md:gap-4 mb-4 md:mb-6">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-xl p-3 md:p-4 lg:p-6 shadow-warm"
        >
          <div className="flex items-center gap-2 md:gap-3 mb-2">
            <div className={`w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 ${stat?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon name={stat?.icon} size={20} className={`md:w-6 md:h-6 ${stat?.color}`} />
            </div>
          </div>
          <p className="text-xs md:text-sm text-muted-foreground mb-1">
            {stat?.label}
          </p>
          <p className="text-lg md:text-xl lg:text-2xl font-bold text-foreground whitespace-nowrap">
            {stat?.value}
          </p>
        </div>
      ))}
    </div>
  );
};

export default PortfolioStats;